import { TokenUtil } from 'services/TokenUtil';
import { ASSIST_API } from 'services/assist-api/axios';
import { getString } from 'utils/parsing';

export const masquerade = async (userId: number): Promise<void> => {
  // Backup tokens
  TokenUtil.backupTokens();

  // Generate new tokens
  const json = (await ASSIST_API.post(`users/${userId}/impersonate`)).data;
  const accessToken = getString('token')(json);
  const refreshToken = getString('refresh_token')(json);

  if (!accessToken || !refreshToken) {
    TokenUtil.removeBackupTokens();
    throw new Error(`Fail to masquerade user (id: ${userId})`);
  }

  // Replace tokens
  TokenUtil.setAccessToken(accessToken);
  TokenUtil.setRefreshToken(refreshToken);
};
